import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=ef04280e&scoped=true"
import script from "./Macro.vue?vue&type=script&lang=js"
export * from "./Macro.vue?vue&type=script&lang=js"
import style0 from "./Macro.vue?vue&type=style&index=0&id=ef04280e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef04280e",
  null
  
)

export default component.exports